import { apiCall } from "../../../services/api-service";


export const getAvailableDockPredictionApi = async (date, time) => {
  return apiCall(
    "GET",
    `futuristic/availability_prediction?date=${date}&time=${time}`
  );
};

export const getDockInPredictionApi = async () => {
  return apiCall("GET", `futuristic/dock_in_prediction`);
};

export const getAllDocksApi = async () => {
  return apiCall("GET", `dock/dockmaster`);
};
export const getQueuePredictionApi = async (dockId) => {
  return apiCall("GET", `futuristic/hourly_dock_prediction?dock_id=${dockId}`);
};

export const getLocationPredictionApi = async () => {
  return apiCall("GET", `futuristic/location_prediction`);
};

export const getLocationListApi = async () => {
  return apiCall("GET", `get_location`, null, {}, { urlType: "admin" });
};

export const getLocationFreePredictionApi = async (locationId) => {
  return apiCall(
    "GET",
    `futuristic/location_free_prediction?location_id=${locationId}`
  );
};
